module.exports = __webpack_public_path__ + "img/wifi-off.46dc05a5.svg";